import { render, staticRenderFns } from "./InitMode.vue?vue&type=template&id=2dfb8c8a&scoped=true"
import script from "./InitMode.vue?vue&type=script&lang=js"
export * from "./InitMode.vue?vue&type=script&lang=js"
import style0 from "./InitMode.vue?vue&type=style&index=0&id=2dfb8c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfb8c8a",
  null
  
)

export default component.exports